export default __webpack_public_path__ + "static/media/leader_notes.a8f29332.pdf";